import { Component, OnInit, ViewEncapsulation, ViewChild, Input, OnChanges, ViewContainerRef  } from '@angular/core';
import { HotToastService } from '@ngneat/hot-toast';

import { DiagramComponent, Diagram, NodeModel, ConnectorModel, SnapSettingsModel, LayoutModel, DataSourceModel, TextModel, DecoratorModel, ShapeStyleModel, UserHandleModel, SelectorModel, SelectorConstraints, ToolBase, MoveTool, MouseEventArgs, cloneObject, randomId, IElement, ContextMenuSettingsModel, BpmnBoundary, BpmnDataObjects, BpmnEvents, BpmnGateways, BpmnLoops, BpmnShapeModel, BpmnTasks, BpmnTriggers, DiagramBeforeMenuOpenEventArgs, NodeConstraints } from '@syncfusion/ej2-angular-diagrams'
import { MenuEventArgs } from '@syncfusion/ej2-angular-navigations';
import { DataManager, DataUtil, Query } from '@syncfusion/ej2-data';
import { BsModalService } from 'ngx-bootstrap';
import { createElement } from 'node_modules/@syncfusion/ej2-base';
import { DemoService } from 'src/app/demo.service';
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';
import { AppRoute } from 'src/app/shared/models/appRoute.model';

@Component({
  selector: 'app-app-routes-diagram-kan-ban-search',
  templateUrl: './app-routes-diagram-kan-ban-search.component.html',
  styleUrls: ['./app-routes-diagram-kan-ban-search.component.scss']
})
export class AppRoutesDiagramKanBanSearchComponent implements OnInit, OnChanges {


     // setup as observable?
     @Input() item_id?; // impliments on changes.
     @Input() item_data?; // if data.model is sent : Observable<any[]>;
     @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
     @Input() item_user_level_id? = '5'; // default to agent just in case
     @Input() item_brand_type_id? = '';
     @Input() show_buttons? = 'no'; // yes | no
     @Input() widget_title? = '';
     @Input() widget_size?; // side | abstract | full
    @Input() current_field_name?;
  
    @Input() promotion_id: number;
    @Input() current_route: any;
  
    array_of_routes: any[];
    search_model: AppRoute;
    public contextMenuSettings: ContextMenuSettingsModel;


  @ViewChild("diagram_ONE")
    public diagram_ONE?: DiagramComponent;
    public snapSettings_ONE?: SnapSettingsModel;
    public items_ONE?: DataManager;
    public layout_ONE?: LayoutModel;
    public dataSourceSettings_ONE?: DataSourceModel;
    //Initializes data source
    // public data_ONE: object[] = [{
    //         Name: "Steve-Ceo"
    //     },
    //     {
    //         Name: "Kevin-Manager",
    //         ReportingPerson: "Steve-Ceo"
    //     },
    //     {
    //         Name: "Peter-Manager",
    //         ReportingPerson: "Steve-Ceo"
    //     },
    //     {
    //         Name: "John- Manager",
    //         ReportingPerson: "Peter-Manager"
    //     },
    //     {
    //         Name: "Mary-CSE ",
    //         ReportingPerson: "Peter-Manager"
    //     },
    //     {
    //         Name: "Jim-CSE ",
    //         ReportingPerson: "Kevin-Manager"
    //     },
    //     {
    //         Name: "Martin-CSE",
    //         ReportingPerson: "Kevin-Manager"
    //     }
    // ];
    app_routes_metrix_search_full: Object;
    app_routes_metrix_search_full_results: any;
    new_data: any;
    data_LOCAL_DATA_RECIEVED: {
        id: string; parentId: string; dataManager: DataManager;
        //binds the external data with node
        doBinding: (nodeModel: NodeModel, data: DataInfo, diagram_ONE: Diagram) => void;
    };








  constructor(
    public gfunc: GlobalFunctionsService,
    private _demoService: DemoService,
    vcr: ViewContainerRef,
    private modalService: BsModalService,
    public toastr: HotToastService,
  ) { }

  ngOnInit(): void {


// Context Menu
 //Enables the context menu
//  this.contextMenuSettings = {
//     //Enables the context menu
//     show: true,
//     items: [
//       {
//         text: "Cut  ",
//         id: "Cut",
//         target: ".e-diagramcontent",
//         iconCss: "e-Cut"
//       },
//       {
//         text: "Copy  ",
//         id: "Copy",
//         target: ".e-diagramcontent",
//         iconCss: "e-Copy"
//       }
//     ],
//     // Hides the default context menu items
//     showCustomMenuOnly: true
//   };


            // this.snapSettings_ONE = {
            // constraints: 0
            // }
            // this.items_ONE = new DataManager(this.data_ONE as JSON[], new Query().take(7));
            // //Uses layout to auto-arrange nodes on the Diagram page
            // this.layout_ONE = {
            // //Sets layout type
            // type: 'HierarchicalTree'
            // }
            // //Configures data source for Diagram
            // this.dataSourceSettings_ONE = {
            // id: 'Name',
            // parentId: 'ReportingPerson',
            // dataSource: this.items_ONE
            // }
            this.toastr.success('Showing on init')

            this.new_data = DataUtil.parse.parseJson(this.item_data)
            console.log('new data'  + JSON.stringify(this.new_data))

  }




  ngOnChanges(changes): void  {

    if (changes.item_data) {
      this.new_data = changes.item_data.currentValue;
      console.log('New Data Loaded: ', JSON.stringify(this.new_data));

this.toastr.success('Showing on changes')
    }


    
  }


    
  getAppRoutesSearchFull(search_model) {
    // search_model.brand_type_id = 3;
    // search_model.access_level = 5;
    this._demoService.getAppRoutesSearchFull(search_model).subscribe(
      data => { this.app_routes_metrix_search_full = data;
       let res = data[0];
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
       
       
        this.app_routes_metrix_search_full_results = DataUtil.parse.parseJson(data);
        // this.subject_service_metrix_search_full_results = data;
        this.new_data = this.app_routes_metrix_search_full_results.slice(0, 500);
  
        // const species: object[] = [
        //   { 'Name': 'Species', 'fillColor': '#3DD94A' },
        //   { 'Name': 'Plants', 'Category': 'Species' },
        //   { 'Name': 'Fungi', 'Category': 'Species' },
        //   { 'Name': 'Lichens', 'Category': 'Species' },
        //   { 'Name': 'Animals', 'Category': 'Species' },
        //   { 'Name': 'Mosses', 'Category': 'Plants' },
        //   { 'Name': 'Ferns', 'Category': 'Plants' },
        //   { 'Name': 'Gymnosperms', 'Category': 'Plants' },
        //   { 'Name': 'Dicotyledens', 'Category': 'Plants' },
        //   { 'Name': 'Monocotyledens', 'Category': 'Plants' },
        //   { 'Name': 'Invertebrates', 'Category': 'Animals' },
        //   { 'Name': 'Vertebrates', 'Category': 'Animals' },
        //   { 'Name': 'Insects', 'Category': 'Invertebrates' },
        //   { 'Name': 'Molluscs', 'Category': 'Invertebrates' },
        //   { 'Name': 'Crustaceans', 'Category': 'Invertebrates' },
        //   { 'Name': 'Others', 'Category': 'Invertebrates' },
        //   { 'Name': 'Fish', 'Category': 'Vertebrates' },
        //   { 'Name': 'Amphibians', 'Category': 'Vertebrates' },
        //   { 'Name': 'Reptiles', 'Category': 'Vertebrates' },
        //   { 'Name': 'Birds', 'Category': 'Vertebrates' },
        //   { 'Name': 'Mammals', 'Category': 'Vertebrates' }
        // ];

        // this.species = species

      //  this.grid.refresh();
    
        },
        error => {
        console.error('Error Loading !' + error.error);
        console.log(error);
        // return Observable.throw(error);
        }
        );     
      }












 //Sets the default properties for all the Nodes
 public getNodeDefaults_ONE(obj: NodeModel, diagram_ONE: Diagram): NodeModel {
  obj.shape = {
      type: 'Text',
      content: (obj.data as {app_route_name: 'string'}).app_route_name
    
  };
  obj.style = {
      fill: 'None',
      strokeColor: 'none',
      strokeWidth: 2,
      bold: true,
      color: 'black'
  };
  let colour = (obj.data as {app_route_colour: 'string'}).app_route_colour
  if(colour != null) {
    obj.borderColor =   (obj.data as {app_route_colour: 'string'}).app_route_colour
  }else{
  obj.borderColor = '#7eafcc';
  }

  
  obj.width = 100;
  obj.height = 40;
  obj.backgroundColor = 'white';
  obj.borderWidth = 1;
  (obj.shape as TextModel).margin = {
      left: 5,
      right: 5,
      top: 5,
      bottom: 5
  };
  return obj;
}

// Make this into a function so that I can set any value with the node type.
//Sets the default properties for all the connectors
public getConnectorDefaults_ONE(connector: ConnectorModel, diagram_ONE: Diagram): ConnectorModel {
  connector.style = {
      strokeColor: '#3e2c42',
      strokeWidth: 2
  };
  (((connector as ConnectorModel).targetDecorator as DecoratorModel).style as ShapeStyleModel).fill = '#fb6e40';
  (((connector as ConnectorModel).targetDecorator as DecoratorModel).style as ShapeStyleModel).strokeColor = '##fb6e40';
  connector.type = 'Orthogonal';
  return connector;
}



}




export interface DataInfo {
    [key: string]: string;
  }




  //Defines the clone tool used to copy Node/Connector
class CloneTool extends MoveTool {
    public diagram_ONE?: Diagram = undefined;
    public override mouseDown(args: MouseEventArgs): void {
      let newObject: NodeModel | ConnectorModel;
      if (((this.diagram_ONE as Diagram).selectedItems.nodes as NodeModel[]).length > 0) {
        newObject = cloneObject(((this.diagram_ONE as Diagram).selectedItems.nodes as NodeModel[])[0]) as NodeModel;
      } else {
        newObject = cloneObject((((this.diagram_ONE as Diagram).selectedItems as SelectorModel).connectors as ConnectorModel[])[0]) as ConnectorModel;
      }
      newObject.id += randomId();
      (this.diagram_ONE as Diagram).paste([newObject]);
      args.source = (this.diagram_ONE as Diagram).nodes[(this.diagram_ONE as Diagram).nodes.length - 1] as IElement;
      args.sourceWrapper = args.source.wrapper;
      super.mouseDown(args);
      this.inAction = true;
    }
  }